module.exports = __webpack_public_path__ + "static/media/3d-plan_general_OnyxCeph3D.5329644a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_general_OnyxCeph3D.svg
// module id = 1036
// module chunks = 0